import React, { useState, useCallback, useEffect } from 'react';
import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel, user as userModel, rtc, note } from '@/models';
import { MemberDeviceType } from '@/models/note';
import { ShareScreenFull } from '@/models/meeting';

export interface ShareScreenStateChangeResp {
  shareMemberUid: string;
  shareMemberDeviceId: string;
  state: number;
  shareMemberDeviceType: MemberDeviceType;
}

export default function useShareScreenStateChange() {
  const {
    meeting,
    rtc: RTCInstance,
    user,
  } = useLocalStore(() => {
    return {
      meeting: meetingModel,
      rtc,
      user: userModel,
    };
  });
  const { formatMessage } = useIntl();

  const shareScreenChange = useCallback(
    (body: ShareScreenStateChangeResp) => {
      const { state, shareMemberUid, shareMemberDeviceId, shareMemberDeviceType } = body;
      note?.setShareMemberDeviceType(shareMemberDeviceType);
      if (state === 0 && meeting.screenName) {
        message.info({
          content: formatMessage({ id: 'STOP_SHARE' }, { name: meeting.screenName }),
          noIcon: true,
        });
      }
      // 1 开启 0 关闭
      if (state === 1) {
        const newScreenUid = shareMemberUid + shareMemberDeviceId;
        meeting.setScreenUid(newScreenUid);
        if (shareMemberUid + shareMemberDeviceId !== user.mid) {
          RTCInstance.closeScreen();
        }
        if (!meeting?.userManualSetPeoplePanel) {
          meeting?.setPeoplePanelShow(false);
        }
      } else {
        meeting.setScreenUid('');
        meeting?.shareScreenFull && meeting?.setShareScreenFull(ShareScreenFull.INIT); // 停止共享如果在全屏就关闭全屏状态
      }
    },
    [meeting, RTCInstance]
  );

  return shareScreenChange;
}
